@if (loading) {
  <div class="loading">
    <mat-progress-spinner [diameter]="64" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
  </div>
}

@if (!loading) {
  <div class="flyout-edit-response-list-component">
    <div class="flyout-headline-row">
      <div class="headline-title">
        @if (this.responseListId) {
          <span>{{ "response-lists.edit.title" | translate }}</span>
        }
        @if (!this.responseListId) {
          <span>{{ "response-lists.edit.create" | translate }}</span>
        }
      </div>
      <div class="header-close-icon">
        <mat-icon class="close-icon" (click)="cancelFlyout()">close</mat-icon>
      </div>
    </div>
    <div class="tools-container">
      <div class="name-container">
        <mat-form-field hideRequiredMarker appearance="outline">
          <mat-label>{{ "response-lists.edit.change-list-name" | translate }}</mat-label>
          <input
            data-test="response-list-edit-name"
            id="name"
            name="name"
            [(ngModel)]="responseList.name"
            matInput
            required
            minlength="1"
            [formControl]="nameFormControl" />
          @if (nameFormControl.hasError("required")) {
            <mat-error>
              {{ "response-lists.edit.name-required" | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    @if (responseListId) {
      <h3>
        {{ "response-lists.edit.columns" | translate }}
      </h3>
    }
    @if (responseListId) {
      <div class="columns-container">
        <div class="edit-column-expansion">
          <div class="key-container">{{ "response-lists.edit.key" | translate }}</div>
          <div class="name-edit">{{ "response-lists.edit.label" | translate }}</div>
        </div>
        @for (column of columns; track column; let i = $index) {
          <div class="edit-column-expansion">
            <section class="key-container">
              <mat-checkbox
                [(ngModel)]="column.selected"
                [disabled]="isDeletingColumn"
                (ngModelChange)="checkBoxSelected()"
                class="example-margin"
                [ngClass]="{ 'empty-name': !column.name || column.name.length == 0 }">
                {{ column.key }}
              </mat-checkbox>
            </section>
            @if (disabledInput[column.type]) {
              <mat-form-field
                matTooltip="{{ 'response-lists.edit.tooltip-non-edit' | translate }}"
                class="name-edit disabled-field"
                hideRequiredMarker
                appearance="outline">
                <input class="remove" [disabled]="true" matInput />
                <span>{{ hardCodedNames[column.type] }}</span>
              </mat-form-field>
            }
            @if (!disabledInput[column.type]) {
              <mat-form-field class="name-edit enabled-field" hideRequiredMarker appearance="outline">
                <input [disabled]="false" matInput [(ngModel)]="column.name" (ngModelChange)="editingName(i)" />
              </mat-form-field>
            }
          </div>
        }
        @if (this.columns.length > 0) {
          <div class="selection-header">
            <app-section-header
              [header]="'settings.users.multiEditMsg' | translate: { items: selectionCount }"
              [subHeader]="null"
              [color]="isDarkTheme ? '#3E4F66' : '#f7f7f7'">
              <div class="button-loader-container">
                @if (isDeletingColumn) {
                  <div>
                    <mat-progress-spinner [diameter]="32" [strokeWidth]="2" mode="indeterminate"></mat-progress-spinner>
                  </div>
                }
                <button
                  [disabled]="selectionCount === 0 || isDeletingColumn"
                  class="delete-button"
                  mat-stroked-button
                  deleteDialog
                  deletionTypeHeader="{{ 'response-lists.edit.delete-header' | translate }}"
                  deletionText="{{ 'response-lists.edit.delete-columns-text' | translate }}"
                  (onDelete)="deleteSelectedRows()">
                  <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                  &nbsp;
                  @if (true) {
                    <span>{{ "response-lists.delete-items" | translate }}</span>
                  }
                </button>
              </div>
            </app-section-header>
          </div>
        }
        <!--
          <mat-form-field appearance="outline">
            <mat-label>{{'response-lists.edit.merge-from-selection' | translate}}</mat-label>
            <mat-select placeholder="{{'response-lists.edit.merge-from-selection' | translate}}"
              (selectionChange)="selectMergeFromColumn()"
              [(ngModel)]="mergeFromColumn">
              <mat-select-trigger>{{mergeFromColumn?.name || mergeFromColumn?.key}}</mat-select-trigger>
              <mat-option *ngFor="let item of mergeFromColumns" [value]="item"  >
                <span style="float:right">{{item.name}}</span>
                <span>{{item.key}}</span>
              </mat-option>
            </mat-select>
            <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
          </mat-form-field>
          <mat-icon matSuffix>keyboard_arrow_right</mat-icon>
          <mat-form-field appearance="outline">
            <mat-label>{{'response-lists.edit.merge-into-selection' | translate}}</mat-label>
            <mat-select placeholder="{{'response-lists.edit.merge-into-selection' | translate}}"
              (selectionChange)="selectMergeIntoColumn()"
              [(ngModel)]="mergeIntoColumn">
              <mat-select-trigger>{{mergeIntoColumn?.name || mergeIntoColumn?.key}}</mat-select-trigger>
              <mat-option *ngFor="let item of mergeIntoColumns" [value]="item"  >
                <span style="float:right">{{item.name}}</span>
                <span>{{item.key}}</span>
              </mat-option>
            </mat-select>
            <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
          </mat-form-field>
          <button *ngIf="true"
            class="delete-button"
            mat-stroked-button
            deleteDialog
            deletionTypeHeader="{{'response-lissts.delete-header' | translate}}"
            deletionText="{{'response-lists.delete-items-text' | translate}}"
            (onDelete)="mergeColumns()">
            <mat-icon>help</mat-icon>&nbsp;
            <span *ngIf="true">{{'response-lists.edit.merge-columns' | translate}}</span>
          </button>
          -->
      </div>
    }
    <div class="flyout-bottom-row">
      <button class="secondary-button" mat-stroked-button (click)="cancelFlyout()">
        <span class="btn-label">{{ "generic.close" | translate | uppercase }}</span>
      </button>
      <button
        data-test="save-response-list"
        [disabled]="nameFormControl.invalid || (responseList.name === originalName && !changedAnyColumnName)"
        class="primary-button"
        mat-stroked-button
        (click)="saveResponseList()">
        <span class="btn-label">{{ "generic.save" | translate | uppercase }}</span>
      </button>
    </div>
  </div>
}
